import React, { useState, useEffect } from 'react';
import { Button, Form, Image, ProgressBar, Badge, Modal, FormText, Accordion, Card, Row, Col, Container } from 'react-bootstrap';
import { BrowserRouter as Router, Navigate, Outlet, Routes, Route } from "react-router-dom";
import Cookies from 'universal-cookie';
import axios from 'axios';

function PrivateRoutes() {

  const [component, setComponent] = React.useState(null);

  async function isMember() {
    const cookies = new Cookies();
    const submitItems = {
        email: cookies.get("e"),
        authToken: cookies.get("t")
    }
    await axios.post(process.env.REACT_APP_BASE_URL + 'jobs/auth/memberverify', submitItems)
      .then( response => {
          // console.log(response.data.status)
          if (response.data.status === 'ok') {
            setComponent(<Outlet />);
          } else {
            setComponent(<Navigate to="/login"></Navigate>);
          }
      }).catch(error => {
        console.error(error);
      });
  }

  React.useEffect(() => {
    isMember();
  }, []);

  return component;

  
}


export default PrivateRoutes;